import React from "react";
import { DuesAmount, Amount, PaymentOption, OptionLabel, OptionSubLabel, PayOnline } from "./StyledComponents";

const PaymentStep = ({
    selectedPaymentOption,
    availableMethods,
    charges,
    totalPayment,
    totalDuesAmount,
    selectedDuesTotal,
    gstAmount,
    isBookingPayment,
    enableDueSelection,
    chargesTransactionLoading,
    isProcessing,
    onPaymentOptionClick,
    onPayNow,
    renderGatewayInfo,
    renderPaymentMethodIcon,
    renderPaymentMethodLabel,
    renderPaymentMethodDescription
}) => {

    const getAmountLabel = () => {
        if (isBookingPayment) return "Booking Amount";
        if (enableDueSelection) return "Selected Dues Amount";
        return "Total Dues Amount";
    };

    const getAmountValue = () => {
        if (isBookingPayment) return totalDuesAmount;
        if (enableDueSelection) return selectedDuesTotal;
        return totalDuesAmount;
    };

    return (
        <div className="px-4 py-4 space-y-4">
            {/* {renderGatewayInfo()} */}

            <div className="flex justify-between">
                <div>
                    <DuesAmount>{getAmountLabel()}</DuesAmount>
                    <Amount>₹{getAmountValue()}</Amount>
                </div>
                {gstAmount > 0 && (
                    <div>
                        <DuesAmount>GST Charges</DuesAmount>
                        <Amount>₹{gstAmount}</Amount>
                    </div>
                )}
                <div>
                    <DuesAmount>Convenience fees</DuesAmount>
                    <Amount>
                        {chargesTransactionLoading ? "Calculating..." : `₹${charges}`}
                    </Amount>
                </div>
            </div>

            <h3>Please select a payment method to proceed.</h3>

            {availableMethods.map((method) => (
                <PaymentOption
                    key={method.type}
                    onClick={() => !chargesTransactionLoading && onPaymentOptionClick(method.type)}
                    className={`${selectedPaymentOption === method.type
                        ? "bg-blue-500 text-white"
                        : "bg-white text-gray-600"
                        } cursor-pointer ${chargesTransactionLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                    {renderPaymentMethodIcon(method.type)}
                    <div>
                        <OptionLabel>
                            {renderPaymentMethodLabel(method.type)}
                        </OptionLabel>
                        <OptionSubLabel
                            className={`${selectedPaymentOption === method.type
                                ? "text-white"
                                : "text-gray-400"
                                }`}
                        >
                            {renderPaymentMethodDescription(method.type)}
                        </OptionSubLabel>
                    </div>
                </PaymentOption>
            ))}

            <div className="flex justify-between items-center">
                <div>
                    <DuesAmount>Total Amount</DuesAmount>
                    <Amount>₹{totalPayment}</Amount>
                </div>
                <div>
                    <PayOnline
                        disabled={isProcessing || chargesTransactionLoading}
                        className={`${isProcessing || chargesTransactionLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                        onClick={onPayNow}
                    >
                        {isProcessing ? "Processing..." : "Pay Now"}
                    </PayOnline>
                </div>
            </div>
        </div>
    );
};

export default PaymentStep;